import { render } from "./RegisterNew.vue?vue&type=template&id=73df6916&scoped=true"
import script from "./RegisterNew.vue?vue&type=script&lang=js"
export * from "./RegisterNew.vue?vue&type=script&lang=js"

import "./RegisterNew.vue?vue&type=style&index=0&id=73df6916&scoped=true&lang=scss"
import "./RegisterNew.vue?vue&type=style&index=1&id=73df6916&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73df6916"]])

export default __exports__